import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './../store'
import axios from "axios"
import fr from "element-ui/src/locale/lang/fr"

Vue.use(VueRouter)

const routes = [
    {
        path: '/MaritimeSilkRoad',
        component: () => import('./../views/layoutHost.vue'),
        children: [
            {
                path: 'selection',
                component: () => import('./../views/selection')
            },
            {
                path: 'personal',
                component: () => import('./../views/personal.vue')
            },
            {
                path: 'tologin',
                component: () => import('./../views/login.vue')
            },
            {
                path: 'registered-shops',
                component: () => import('../views/registeredShops')
            },
            {
                path: 'selection',
                component: () => import('../views/selection.vue')
            },
            {
                path: 'baseEdit',
                component: () => import('../views/baseEdit.vue')
            },
            {
                path: 'imgEdit',
                component: () => import('../views/imgEdit.vue')
            },
            {
                path: 'priceEdit',
                component: () => import('../views/priceEdit.vue')
            },
            {
                path: 'logisticsEdit',
                component: () => import('../views/logisticsEdit.vue')
            },
            {
                path: 'edit',
                component: () => import('../views/edit.vue')
            },
            {
                path: 'optimize',
                component: () => import('../views/optimize.vue')
            },
            {
                path: 'product',
                component: () => import('../views/product.vue')
            },
            {
                path: 'order',
                component: () => import('../views/order.vue')
            },
            {
                path: 'financial',
                component: () => import('../views/financial.vue')
            },
            {
                path: 'service',
                component: () => import('../views/service.vue')
            },
            {
                path: 'test',
                component: () => import('../views/test.vue')
            },
            {
                path: 'mobileClient',
                component: () => import('../views/mobileClient.vue')
            },
        ]
    },
    {
        path: '/RegisterShop',
        component: () => import('./../views/layoutRegister.vue'),
        children: [
            {
                path: 'initialize',
                component: () => import('./../views/shopSetting')
            }
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
router.beforeEach((to, from, next) => {
    if (from.path === '/MaritimeSilkRoad/mobileClient') {
        next()
    } else {
        try {
            let $routerRecord = store.state.routerRecord || [];
            $routerRecord.push(from.path)
            store.commit('setData', {setKey: 'routerRecord', value: $routerRecord})
        }catch (e) {
            console.log(e)
        }
        next()
    }
})

export default router
